import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundImage from '../Assets/web.png';

const PageNotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 sm:py-2">
      <div className="max-w-xl w-full text-center">
        <div className="mx-auto mb-6 aspect-square w-48 sm:w-64 overflow-hidden rounded-lg">
          <img
            src={NotFoundImage}
            alt="404 Not Found"
            className="w-full h-full object-cover"
          />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Oops! Page Not Found
        </h1>
        <p className="text-white mb-8">
          The page you're looking for doesn't exist. Please try one of the options below:
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <Link to="/" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto px-6 py-3 bg-indigo-600 text-white rounded-md font-semibold hover:bg-indigo-500 transition">
              Go Home
            </button>
          </Link>
          <Link to="/blogs" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto px-6 py-3 bg-indigo-600 text-white rounded-md font-semibold hover:bg-indigo-500 transition">
              Visit Our Blogs
            </button>
          </Link>
          <Link to="/help-Center" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto px-6 py-3 bg-indigo-600 text-white rounded-md font-semibold hover:bg-indigo-500 transition">
              Get Help
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;

